<div nz-row [nzGutter]="25">
  <!-- skeleton -->
  <ng-template #loadingSkeleton>
    <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzAvatar]="true" [nzActive]="true"
      [nzParagraph]="{ rows: 4 }"></nz-skeleton>
  </ng-template>
  <ng-template #loadingSkeleton2>
    <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzAvatar]="true" [nzActive]="true"
      [nzParagraph]="{ rows: 15 }"></nz-skeleton>
  </ng-template>
  <!-- skeleton -->

  <div nz-col nzXs="24" class="mb-[25px]">
    <ng-container *ngIf="showContent; else loadingSkeleton">
      <app-ticket-overview></app-ticket-overview>
    </ng-container>
  </div>
  <div nz-col nzXs="24" class="mb-[25px]">
    <ng-container *ngIf="showContent; else loadingSkeleton2">
      <ticket-table></ticket-table>
    </ng-container>
  </div>
</div>

